import { EducatorsTeamsInvitationIndex } from "@/types/serializers"
import { useProps } from "@/lib/page-rendering"

export type IndexProps = {
  invitations: Array<EducatorsTeamsInvitationIndex>
  team_name: string
}

export const useIndexProps = () => useProps<IndexProps>()
